<template>
    <div>

        <form class="page-form form-horizontal" @submit.prevent="submit()">

            <div v-if="this.last_created.createdBy" class="alert alert-info" role="alert">
                Último sitemap generado el: <strong>{{ moment(this.last_created.createdAt.date).format('LLLL') }}</strong>.<br>
                Sitemap generado por: <strong>{{ this.last_created.createdBy }}</strong>
                <br><a href="/sitemap" target="_blank"><u>Ver sitemap</u></a>
            </div>
            <div v-else class="alert alert-warning" role="alert">No existen sitemaps creados con anterioridad.</div>



            <div class="form-group">
                <label for="hostName" class="col-sm-2 control-label">Exclusiones</label>
                <div class="col-sm-10">
                    <div>
                        El sitemap a generar no incluye las siguientes URL:<br>
                        <br>
                        <ul class="list-group">
                            <li class="list-group-item">URLs bajo el segmento <strong>/backend</strong> </li>
                            <li class="list-group-item">URLs bajo el segmento <strong>/mi-cha</strong> (Mi ChileAtiende)</li>
                            <li class="list-group-item">URLs bajo el segmento <strong>/tramites</strong> (Fichas Transaccionales)</li>
                            <li class="list-group-item">URLs bajo el segmento <strong>/desarrolladores</strong> (API)</li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div v-if="responseXml && !isLoading" class="form-group">
                <label for="moduleName" class="col-sm-2 control-label">Respuesta XML</label>
                <div v-if="responseXml && !isLoading" class="col-sm-10">
                    <div style="max-height: 500px; overflow-y: scroll;">
                        <pre><code>{{ responseXml }}</code></pre>
                    </div>
                    <br><label>Se ha creado una nueva versión del sitemap del sitio y está disponible en <a href="/sitemap" target="_blank"><u> {{ sitemapForm.hostName }}/sitemap</u></a></label>
                </div>                
            </div>

            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <loader v-if="isLoading"></loader>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <button v-if="!responseXml" type="submit" class="btn btn-primary">Generar sitemap</button>
                </div>
            </div>

        </form>

    </div>
</template>

<script>
    import Loader from './Loader.vue'
    export default {
        name: 'sitemap-form',
        components: {
            Loader
        },
        data: function(){
            var host = baseUrl.split('://'); 
            return{
                isLoading: false,
                moment: moment,
                sitemapForm: {
                    moduleNames: {
                        'pages': true,
                        'contents': true,
                        'staticContent': true,
                        'institutions': true,
                    },
                    hostName: host[1],
                    protocol: host[0],
                },
                responseXml: null,
                errors: {},
            }
        },
        filters: {
            filterFieldName: function (fieldName) {
                return fieldName.replace('module names', 'selección de módulos')
            },
        },
        props: ['last_created'],
        methods: {
            downloadSitemapFile: function () {
                var sitemap = window.document.createElement('a');
                sitemap.href = window.URL.createObjectURL(new Blob([this.responseXml], {type: 'text/xml'}));
                sitemap.download = 'sitemap.xml';
                document.body.appendChild(sitemap);
                sitemap.click();
                document.body.removeChild(sitemap);
            },
            submit: function(){
                let self = this
                self.isLoading = true
                self.responseXml = null
                self.errors = {}

                for (let s in this.sitemapForm.moduleNames) {
                    if (this.sitemapForm.moduleNames[s] == false) {
                        delete this.sitemapForm.moduleNames[s]
                    }
                }

                axios({
                    url: 'backend/sitemap',
                    method: 'POST',
                    data: this.sitemapForm,
                }).then(function(response){

                    self.responseXml = response.data
                    self.isLoading = false
                }).catch(function(error){
                    self.errors = error.response.data.errors
                    self.isLoading = false
                })
            },
        }

    }
</script>
